<div class="mb-2">
  <div class="flex flex-row items-center justify-between opacity-50">
    <div class="!text-xs cursor-pointer back-btn" (click)="back()">
      <i class="pi pi-arrow-left !text-xs"></i>
      <span class="hide-left-small ml-2">{{ 'Back' | translate }}</span>
    </div>
    <button
      pButton
      icon="pi pi-times"
      class="p-button-text p-button-plain p-button-rounded hide-left-small cursor-pointer"
      (click)="toggleSideBar()"></button>
  </div>
</div>

@for (mainItem of moduleMenuItems; track $index) {
  @if (mainItem?.visible !== false) {
    <div class="font-extrabold text-xs uppercase mb-1 mt-4 hide-left-small">
      {{ mainItem.label | translate }}
    </div>
  }

  @for (item of mainItem.items; track $index) {
    @if (item?.visible !== false) {
      <a
        class="flex items-center py-1 cursor-pointer gap-2 left-menu-link"
        [routerLink]="item.link"
        (click)="item.commandname ? commandSelector(item.commandname) : ''; closeMenu()">
        <span
          class="inline-flex items-center justify-center text-blue-500 left-menu-icon"
          [pTooltip]="item.label | translate">
          <mat-icon fontIcon="{{ item.icon ? item.icon : 'add_circle' }}" />
        </span>
        <span
          class="inline-flex flex-col gap-2 hide-left-small {{
            module_active === item?.link ? 'opacity-100' : 'opacity-60'
          }}">
          <span
            class="text-sm {{ module_active === item?.link ? '!font-bold !text-primary' : '' }}"
            >{{ item.label | translate }}</span
          >
        </span>
      </a>
    }
  }
}
